import { Link, useLoaderData } from '@remix-run/react'
import { ArrowDown, HomeIcon, InfoIcon } from 'lucide-react'
import { useLocalStorage } from 'usehooks-ts'
import { type LayoutLoaderData } from '#app/routes/_layout+/_layout'
import { useStoreContext } from '#app/store'
import { Button } from './ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from './ui/tooltip'

export function Footer() {
	const { user } = useLoaderData<LayoutLoaderData>()

	const getUserPlots = useStoreContext(s => s.getUserPlots)
	const userPlots = user ? getUserPlots(user?.id) : []

	const [showNewUserTooltip, setShowNewUserTooltip] = useLocalStorage(
		'showNewUserTooltip',
		true,
	)

	const showTooltip = userPlots.length === 0 && showNewUserTooltip

	return (
		<footer
			className="fixed bottom-4 right-2 z-10 h-10  
			md:right-6"
		>
			<Button
				variant="link"
				asChild
				className="relative mt-0.5 !h-10 w-10 rounded-full border bg-background"
				onClick={() => setShowNewUserTooltip(false)}
			>
				<Link to="/info">
					<HomeIcon className="h-6 w-6" />
					<InfoIcon className="absolute bottom-1 right-1 h-3.5 w-3.5 fill-white" />
				</Link>
			</Button>

			<TooltipProvider>
				<Tooltip open={showTooltip}>
					<TooltipTrigger asChild>
						<span className="pointer-events-none absolute left-0 top-0 h-full w-full"></span>
					</TooltipTrigger>
					<TooltipContent
						align="end"
						alignOffset={0}
						sideOffset={8}
						className="d flex items-center gap-1"
						onClick={() => setShowNewUserTooltip(false)}
					>
						What is Erda? <ArrowDown className="h-4 w-4" />
					</TooltipContent>
				</Tooltip>
			</TooltipProvider>
		</footer>
	)
}
